<!-- 表面处理 -->
<template>
  <BaseFormItem
    :label="fields.label"
    :labelTips="fields.labelTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
  >
    <BaseRadioGroup v-model="val" @change="handleEmit">
      <el-radio-button
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :disabled="item.disabled"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup>
  </BaseFormItem>
</template>

<script>
import { getFR4Fields } from '@@/utils/getFields'
import { alertFieldsTips } from '@@/utils/alertFieldsTips'

export default {
  props: {
    value: {
      type: String,
      default: '有铅喷锡'
    },
    // 板子层数
    blayer: {
      type: Number,
      default: 2
    },
    // 半孔
    bankong: {
      type: Number,
      default: 0
    },
    // 包边
    baobian: {
      type: Number,
      default: 0
    },
    // TODO
    // 禁用OSP 
    disosp: {
      type: Boolean,
      default: false
    },
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value,
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
    }
  },
  computed: {
    fields() {
      return getFR4Fields('spray')
    },
    options() {
      const { fields, bankong, baobian } = this
      const options = fields.options
      let disabledOptions = bankong > 0 || baobian > 0 ? ['OSP'] : []
      
      return options.map(item => ({...item, disabled: disabledOptions.includes(item.value) }))
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
    blayer(blayer) {
      // 当板子层数大于8层，设当前值为'沉金'
      if (blayer > 8) {
        if(this.val != '沉金') {
          this.changeVal('沉金')
        }
      } else if (this.val != '有铅喷锡') {
        this.changeVal('有铅喷锡')
      }
    },
    bankong() {
      this.bankongOrBaobianChange()
    },
    baobian() {
      this.bankongOrBaobianChange()
    }
  },
  methods: {
    handleEmit() {
      const { val, value } = this
      this.$emit('input', val)
      if (val != value) {
        this.$emit('change', val)
      }
      this.isShowError(false)
    },
    changeVal(val) {
      if (this.initPcbParamsChange) return
      alertFieldsTips(this.fields.label)
      this.val = val
      this.handleEmit()
    },
    // 半孔/包边改变时
    bankongOrBaobianChange() {
      const { val, options, bankong, baobian } = this
      const disabledOptions = options.filter(item => item.disabled).map(item => item.value)
      // 有半孔/包边，且当前所选项(OSP)被禁用
      if ((bankong > 0 || baobian > 0) && disabledOptions.includes(val)) {
        // 设当前值为可选项第一个选项的值
        this.val = this.options.filter(item => !item.disabled)[0].value
        this.handleEmit()
        // 弹出提示
        this.$alert(`有半孔/包边的板子，表面处理不能做${val}`, '温馨提示', {
          confirmButtonText: '好的',
          lockScroll: false,
          center: true,
          closeOnPressEscape: true
        })
      }
    },
    // 是否显示错误提示样式
    isShowError(isShow, isBlink = false) {
      this.isError = isShow
      this.isErrorBlink = isBlink
    }
  }
}
</script>

<style lang="scss" scoped>
</style>